import React, { useState } from "react";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useData } from "../context/Context"; // Import the custom hook to access the data

const status = [
  {
    id: 0,
    name: "Not Started",
  },
  {
    id: 1,
    name: "High Quality",
  },
  {
    id: 2,
    name: "Partial",
  },
  {
    id: 5,
    name: "Re Texture",
  },
  {
    id: 3,
    name: "Dont Keep",
  },
  {
    id: 4,
    name: "Environment",
  },
];

const ModelStatusFilter = () => {
  const {
    state: { selected_status },
    setState,
  } = useData();

  // Find the selected status object based on the context state
  const selected = status.find((s) => s.id === selected_status) || status[0];

  const handleStatusChange = (status) => {
    // Update the selected status in the context
    setState((prev) => ({
      ...prev,
      selected_status: status.id,
    }));
  };

  return (
    <Listbox value={selected} onChange={handleStatusChange}>
      <Label className="block font-semibold text-[15px] text-[#858585] leading-6">
        Model Status Filter
      </Label>
      <div className="relative mt-2">
        <ListboxButton className="relative sm:w-[10%] w-[60%] cursor-default rounded-md bg-[#A0A3A6] py-1.5 pl-3 pr-10 text-left text-[#06090B] shadow-sm ring-1 ring-inset ring-[#06090B] focus:outline-none focus:ring-2 focus:ring-[#FF9900] sm:text-sm sm:leading-6">
          <span className="flex items-center">
            <span className="ml-3 block truncate">{selected.name}</span>
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
            <ChevronUpDownIcon
              aria-hidden="true"
              className="h-5 w-5 text-[#06090B]"
            />
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute mt-1 sm:ml-[45%] ml-[20%] max-h-56 sm:w-[10%] w-[60%] overflow-auto rounded-md bg-[#A0A3A6] py-1 text-base shadow-lg ring-1 ring-[#FF9900] ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm z-50"
        >
          {status.map((state) => (
            <ListboxOption
              key={state.id}
              value={state}
              className="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-[#06090B] data-[focus]:bg-[#FF9900] data-[focus]:text-[#06090B]"
            >
              <div className="flex items-center">
                <span className="ml-3 block truncate font-normal group-data-[selected]:font-semibold">
                  {state.name}
                </span>
              </div>

              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-[#06090B] group-data-[focus]:text-[#06090B] [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};

export default ModelStatusFilter;
